import { isNil } from 'lodash';

export type TMultiSelectFieldValidatorContext = {
  isRequired: boolean,
  minSelection: number,
  maxSelection: number,
};

export class MultiSelectFieldValidator {
  private static DEFAULT_CONTEXT: TMultiSelectFieldValidatorContext = {
    isRequired: false,
    minSelection: 0,
    maxSelection: 1000,
  };

  private _context: TMultiSelectFieldValidatorContext;

  constructor(context: TMultiSelectFieldValidatorContext) {
    this._context = context;
  }

  static withContext(context: Partial<TMultiSelectFieldValidatorContext>) {
    return new MultiSelectFieldValidator({ ...this.DEFAULT_CONTEXT, ...context });
  }

  validate(values: string[]): string {
    if (!isNil(this._context.maxSelection) && values.length > this._context.maxSelection) {
      return `At most ${this._context.maxSelection} selection(s) are allowed.`;
    }

    /**
     * In case AVD is misconfigured such that
     * - field.required === true && minSelection === 0, field.required takes priority
     * - field.required === false && minSelection > 0, don't validate minSelection
     */
    if (this._context.isRequired) {
      if (!isNil(this._context.minSelection) && this._context.minSelection > 0 && values.length < this._context.minSelection) {
        return `At least ${this._context.minSelection} selection(s) are required.`;
      } else if (values.length === 0) {
        return `This field is required.`;
      }
    }
    // Else don't validate minSelection
  }
}
